"use client";

import { Check, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Pricing() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: reassuranceRef,
    isVisible: reassuranceVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="124" id="pricingoverview" className="relative overflow-hidden bg-background py-24 sm:py-32">
      <div className="pointer-events-none absolute inset-0 opacity-40" aria-hidden="true">
        <div className="absolute left-1/2 top-0 h-[500px] w-[800px] -translate-x-1/2 rounded-lg bg-[radial-gradient(ellipse_at_center,var(--primary)_0%,transparent_70%)] opacity-20 blur-3xl" />
        <div className="absolute bottom-0 right-0 h-[400px] w-[600px] rounded-lg bg-[radial-gradient(ellipse_at_center,var(--chart-2)_0%,transparent_70%)] opacity-10 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        <div ref={headerRef} className={`mx-auto max-w-3xl text-center transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="mb-5 inline-flex items-center gap-2 rounded-md border border-border bg-card px-3 py-1 text-xs font-medium text-muted-foreground font-mono uppercase tracking-wider">
            <Sparkles className="size-3 text-primary" />
            Unsere Leistungen
          </div>
          <h2 className="font-default text-4xl font-bold tracking-tight text-foreground sm:text-5xl lg:text-6xl"> Service-Pakete</h2>
          <p className="mt-6 text-lg leading-relaxed text-muted-foreground">Lösungen für Steuergeräte</p>
          <h3 className="mt-8 font-default text-2xl font-semibold tracking-tight text-primary">
            Klonen
          </h3>
        </div>

        <div ref={gridRef} className={`mx-auto mt-20 grid max-w-md grid-cols-1 gap-8 lg:max-w-7xl lg:grid-cols-3 lg:items-stretch transition-all duration-700 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div data-index={0} className="relative flex flex-col rounded-lg border border-border bg-card p-10 shadow-md">
            <div className="font-mono text-xs uppercase tracking-widest text-primary">Einfaches Steuergerät-Klonen<br /><br /></div>
            <div className="mt-4 flex items-baseline gap-2">
              <span className="font-default text-6xl font-bold tracking-tight text-foreground">AB 100 €</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-muted-foreground whitespace-pre-wrap">Klonen eines Steuergeräts per OBD oder Bench (Standardfall)</p>

            <ul className="mt-8 flex flex-1 flex-col gap-4">
              <li data-index={0} className="flex items-start gap-3 text-sm text-foreground">
                <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground">
                  <Check className="size-3" strokeWidth={3} />
                </span>
                <span className="leading-relaxed">Auslesen & Übertragen der Originaldaten auf das Ersatzsteuergerät</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-foreground">
                <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground">
                  <Check className="size-3" strokeWidth={3} />
                </span>
                <span className="leading-relaxed">OBD‑ oder Bench‑Zugriff – kein Öffnen oder Löten erforderlich</span>
              </li>
            </ul>

            <div className="mt-8 space-y-4 text-sm text-muted-foreground">
              <div>
                <p className="font-bold text-foreground">Anlieferung & Vor-Ort-Service</p>
                <p>Die angegebenen Preise gelten bei Anlieferung oder Zusendung der ausgebauten Steuergeräte.<br /><br /></p>
                <p>Vor-Ort-Service nach Absprache möglich.</p>
                <p>Anfahrt: 0,50 € pro gefahrenem Kilometer (inkl. Hin- und Rückfahrt).<br /><br /></p>
                
                
              </div>
            </div>

            <Button asChild variant="default" size="lg" className="mt-10 w-full bg-primary text-white hover:bg-primary/90">
              <Link to="/ContactPage">Jetzt anfragen</Link>
            </Button>
          </div>

          <div data-index={1} className="relative flex flex-col rounded-lg border border-border bg-card p-10 shadow-md">
            <div className="relative flex flex-1 flex-col">
              <div className="font-mono text-xs uppercase tracking-widest text-primary">Steuergeräte mit höherem Aufwand<br /><br /></div>
              <div className="mt-4 flex items-baseline gap-2">
                <span className="font-default text-6xl font-bold tracking-tight text-foreground">AB 150 €</span>
              </div>
                  <p className="mt-4 text-sm leading-relaxed text-muted-foreground whitespace-pre-wrap">Klonen eines Steuergeräts mit Boot-, BDM-, JTAG- oder ISP-Zugriff</p>

                  <ul className="mt-8 flex flex-col gap-4">
                    <li data-index={0} className="flex items-start gap-3 text-sm text-foreground">
                      <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                        <Check className="size-3" strokeWidth={3} />
                      </span>
                      <span className="leading-relaxed">Auslesen & Übertragen der Originaldaten auf das Ersatzsteuergerät</span>
                    </li>
                    <li className="flex items-start gap-3 text-sm text-foreground">
                      <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                        <Check className="size-3" strokeWidth={3} />
                      </span>
                      <span className="leading-relaxed">Lötarbeiten oder Spezialadapter können erforderlich sein</span>
                    </li>
                    <li className="flex items-start gap-3 text-sm text-foreground">
                      <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                        <Check className="size-3" strokeWidth={3} />
                      </span>
                      <span className="leading-relaxed">Steuergerät muss geöffnet und/oder im Boot-Modus ausgelesen werden.</span>
                    </li>
                  </ul>

                  <div className="mt-8 space-y-4 text-sm text-muted-foreground">
                    <div>
                      <p className="font-bold text-foreground">Anlieferung & Vor-Ort-Service</p>
                      <p>Die angegebenen Preise gelten bei Anlieferung oder Zusendung der ausgebauten Steuergeräte.<br /><br /></p>
                      <p>Vor-Ort-Service nach Absprache möglich.</p>
                      <p>Anfahrt: 0,50 € pro gefahrenem Kilometer (inkl. Hin- und Rückfahrt).<br /><br /></p>
                      
                      
                    </div>
                  </div>

                  <Button asChild size="lg" className="mt-10 w-full bg-primary text-white hover:bg-primary/90">
                    <Link to="/ContactPage">Jetzt anfragen</Link>
                  </Button>
                </div>
              </div><div data-index={1} className="relative flex flex-col rounded-lg border border-border bg-card p-10 shadow-md">
            <div className="relative flex flex-1 flex-col">
              <div className="font-mono text-xs uppercase tracking-widest text-primary">ORIGINALDATEN SICHERN<br /><br /></div>
              <div className="mt-4 flex items-baseline gap-2">
                <span className="font-default text-6xl font-bold tracking-tight text-foreground">AB 40 €</span>
              </div>
                  <p className="mt-4 text-sm leading-relaxed text-muted-foreground whitespace-pre-wrap">Auslesen und Sichern der Originaldaten vor Softwareanpassungen oder Reparaturen.</p>

                  <ul className="mt-8 flex flex-col gap-4">
                    <li data-index={0} className="flex items-start gap-3 text-sm text-foreground"><span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow" data-ast-id="f:/src/pages/KeyService/sections/PricingCopy.tsx|sig:5qkm2y" data-ast-start="9564" data-ast-end="10257"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check size-3" aria-hidden="true" data-ast-id="f:/src/pages/KeyService/sections/PricingCopy.tsx|sig:sl28zd" data-ast-start="9856" data-ast-end="10250"><path d="M20 6 9 17l-5-5" data-ast-id="f:/src/pages/KeyService/sections/PricingCopy.tsx|sig:pldgp2" data-ast-start="10211" data-ast-end="10244"></path></svg></span><span className="leading-relaxed" data-ast-id="f:/src/pages/KeyService/sections/PricingCopy.tsx|sig:esr3o" data-ast-start="10257" data-ast-end="10470" style={{}}>Originaldaten auslesen und sichern<br /><br /></span></li>
                    <li className="flex items-start gap-3 text-sm text-foreground">
                      <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow">
                        <Check className="size-3" strokeWidth={3} />
                      </span>
                      <span className="leading-relaxed">Originaldaten können auf Wunsch mitgegeben werden</span>
                    </li>
                    <li className="flex items-start gap-3 text-sm text-foreground"><span className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-gradient-to-br from-[var(--chart-2)] to-[var(--primary)] text-primary-foreground shadow" data-ast-id="f:/src/pages/KeyService/sections/PricingCopy.tsx|sig:5qkm2y" data-ast-start="10621" data-ast-end="10896"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-check size-3" aria-hidden="true" data-ast-id="f:/src/pages/KeyService/sections/PricingCopy.tsx|sig:t2nfge" data-ast-start="10822" data-ast-end="10866"><path d="M20 6 9 17l-5-5"></path></svg></span><span className="leading-relaxed" data-ast-id="f:/src/pages/KeyService/sections/PricingCopy.tsx|sig:esr3o" data-ast-start="10919" data-ast-end="11027">Nur zuvor gesicherte Originaldaten können später wiederhergestellt werden</span></li>
                  </ul>

                  <div className="mt-8 space-y-4 text-sm text-muted-foreground">
                    <div>
                      <p className="font-bold text-foreground">Anlieferung & Vor-Ort-Service</p>
                      <p>Die angegebenen Preise gelten bei Anlieferung oder Zusendung der ausgebauten Steuergeräte.<br /><br /></p>
                      <p>Vor-Ort-Service nach Absprache möglich.</p>
                      <p>Anfahrt: 0,50 € pro gefahrenem Kilometer (inkl. Hin- und Rückfahrt).<br /><br /></p>
                      
                      
                    </div>
                  </div>

                  <Button asChild size="lg" className="mt-10 w-full bg-primary text-white hover:bg-primary/90">
                    <Link to="/ContactPage">Jetzt anfragen</Link>
                  </Button>
                </div>
              </div>

          
        </div>

        
      </div>
    </section>;
}